import { Flex, Typography } from "antd";
import styles from "./index.module.less";
import { JobDto } from "../../../constant";
import TimeIcon from "../../imgs/time.svg?react";
import LocationIcon from "../../imgs/location.svg?react";
import CategoryIcon from "../../imgs/category.svg?react";
import SVGIcon from "@/components/SVGIcon";
const { Paragraph } = Typography;
const JobCard = ({ data, onClick }: { data: JobDto; onClick: () => void }) => {
  const { title, desc, date, locations, category } = data;
  return (
    <div className={styles.jobCard} onClick={onClick}>
      <Flex vertical gap={".12rem"} className={styles.header}>
        <div className={styles.jobTitle}>{title}</div>
        <Flex gap={".2rem"} className={styles.jobInfo} align="center">
          <Flex align="center" gap={4}>
            <SVGIcon icon={<CategoryIcon />} />
            {category}
          </Flex>
          <Flex align="center" gap={4}>
            <SVGIcon icon={<LocationIcon />} />
            {locations.join(",")}
          </Flex>
          <Flex align="center" gap={4}>
            <SVGIcon icon={<TimeIcon />} />
            {date}
          </Flex>
        </Flex>
      </Flex>
      <Paragraph
        ellipsis={{
          rows: 2,
        }}
        className={styles.jobDesc}
      >
        {desc}
      </Paragraph>
    </div>
  );
};
export default JobCard;
